import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const getAuthHeader = () => {
    const token = localStorage.getItem('auth_token');
    return { Authorization: `Bearer ${token}` };
};

const analyticsService = {
    // 1. Get Course Analytics
    getCourseAnalytics: async (courseId) => {
        try {
            const response = await axios.get(`${API_URL}/analytics/course/${courseId}/overview`, {
                headers: getAuthHeader()
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching analytics:", error);
            throw error;
        }
    },

    // 2. Get ALMA Recommendations
    getRecommendations: async (courseId) => {
        try {
            const response = await axios.get(`${API_URL}/analytics/course/${courseId}/recommendations`, {
                headers: getAuthHeader()
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching recommendations:", error);
            throw error;
        }
    },

    // 3. Get Quiz Questions
    getQuizQuestions: async (artefactId) => {
        try {
            const response = await axios.get(`${API_URL}/quiz/artefact/${artefactId}/questions`, {
                headers: getAuthHeader()
            });
            return response.data.questions;
        } catch (error) {
            console.error("Error fetching quiz questions:", error);
            throw error;
        }
    },

    // 4. Submit Quiz Answer
    submitQuizAnswer: async (payload) => {
        try {
            const response = await axios.post(`${API_URL}/quiz/submit-answer`, payload, {
                headers: getAuthHeader()
            });
            return response.data;
        } catch (error) {
            console.error("Error submitting quiz answer:", error);
            throw error;
        }
    },

    // 5. Get Quiz Attempts
    getQuizAttempts: async (artefactId) => {
        try {
            const response = await axios.get(`${API_URL}/quiz/artefact/${artefactId}/attempts`, {
                headers: getAuthHeader()
            });
            return response.data.attempts;
        } catch (error) {
            console.error("Error fetching quiz attempts:", error);
            throw error;
        }
    },

    // 6. Get Performance Analysis (AI)
    getPerformanceAnalysis: async (courseId) => {
        try {
            const response = await axios.get(`${API_URL}/analytics/course/${courseId}/performance-analysis`, {
                headers: getAuthHeader()
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching performance analysis:", error);
            throw error; // Return null/error handled by caller
        }
    },

    // 7. Complete Quiz (Final Submission)
    completeQuiz: async (payload) => {
        try {
            // payload: { course_id, artefact_id, percentage, score, total_questions, passed }
            const response = await axios.post(`${API_URL}/quiz/complete`, payload, {
                headers: getAuthHeader()
            });
            return response.data;
        } catch (error) {
            console.error("Error completing quiz:", error);
            throw error;
        }
    }
};

export default analyticsService;
